import React, { createContext, useContext, useState, useCallback, PropsWithChildren } from 'react';

type DashboardRefreshContextType = {
  shouldRefresh: boolean;
  refresh: (val?: boolean) => void;
};

const DashboardRefreshContext = createContext<DashboardRefreshContextType | undefined>(undefined);

export function DashboardRefreshProvider({ children }: PropsWithChildren) {
  const [shouldRefresh, setShouldRefresh] = useState(false);
  
  const refresh = (val?: boolean) => setShouldRefresh(v => val || !v);
  return (
    <DashboardRefreshContext.Provider value={{ shouldRefresh, refresh }}>
      {children}
    </DashboardRefreshContext.Provider>
  );
}

export function useDashboardRefresh() {
  const ctx = useContext(DashboardRefreshContext);
  if (!ctx) throw new Error('useDashboardRefresh must be used within <DashboardRefreshProvider>');
  return ctx;
}